import React from 'react';
import './landingPage.css';
import './landingPage_Tablet.css';
import './landingPage_Mobile.css';
import './luckObservation.css';
import Loading from '../Loading.js';
import { Redirect } from 'react-router';
import { domain } from '../../common/config.js';
import MediaQuery from 'react-responsive';
import { apiService, axiosCallService } from '../../common/apiCallService';
import { baseUrl } from '../../common/config.js';
import { LearnMoreHome, MeetWhiz } from './commonComponents';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import Observations from './Observations';
import i18next from 'i18next'
import LearnMore from "../LearnMore/LearnMore";
import LandingPageFilter from './LandingPageFilter';
import queryString from 'query-string';
import AnalysingHands from './AnalysingHands';
import OnBoard from "../MygameOnBoard/OnBoard";
import LandingTab from "../LandingPage/LandingTab";
import { updateOnBoard, saveActivity } from '../../common/commonService';
import { getColor, getTextColor } from '../../common/ThemeService';
import { DispatcherFunction } from 'mygame-components';
const WhizHelmet = "/LandingPage/HeadWink.gif";
const backgroundImage = "/images/LandingPage/landingBg.png";

class BaseStructure extends React.Component {
    constructor(props) {
        super(props);
        const searchData = queryString.parse(this.props.location.search)
        this.state = {
            location: '',
            wnd: null,
            title: 'MyGame Home',
            learnMoreType: '',
            count: 1,
            loading: false,
            openFilter: false,
            prevGameType: '',
            changeOrder: false,
            isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0,
            accountName: localStorage.getItem('accountName'),
            gameType: searchData.gameType ? searchData.gameType : 'cash',
            ringType: searchData.ringType ? searchData.ringType : '6-seater',
            dateRange: searchData.dateRange ? searchData.dateRange : 'Today',
            gameSubType: searchData.gameSubType ? searchData.gameSubType : 'NLH',
            totalHandPlayed: searchData.totalHandPlayed,
            gameHandsCounts: {},
            lastVisit: false,
            fromClient:JSON.parse(localStorage.getItem('fromClient',false)),
            respon:false
            //download_redirecturl:{PartyPoker:" https://promo.partypoker.com/en/promo/launch?P=PartyPoker",CORAL:"https://poker.coral.co.uk/en/poker",bwin:"https://promo.bwin.com/en/promo/launch?P=bwin",LADBROKEUK:"https://promo.ladbrokes.com/en/promo/launch?P=ladbrokes"}
        }
    }

    checkLastHandsDtls = async () => {
        if (JSON.parse(localStorage.getItem('userRole')).includes('PLAYER')) {
            let location = '/',
                playerData = await axiosCallService(`/reportCard/getLast48HrsDtls`, {
                    accountName: localStorage.getItem('accountName'), gameType: ['cash', 'tournament', 'Spin'],
                    gameSubType: ['Texas Holdem', 'Omaha Hi'],
                    ringType: ['6-seater', 'Full Ring', 'Heads-up'],
                    userType: localStorage.getItem("loggedInType")
                });
            let gameType = "cash", gameSubType = "NLH", ringType = "6-seater", dateRange = "Today", totalHandPlayed = 0, changeOrder = false
            // if (!(([ 'spin','plo'].includes((playerData.data.gameType).toLowerCase())) || playerData.data.gameType === 'Omaha Hi')) {
            gameType = playerData.data.gameType
            gameSubType = playerData.data.gameSubType
            ringType = playerData.data.ringType
            dateRange = playerData.data.dateRange
            totalHandPlayed = playerData.data.totalHandPlayed,
                changeOrder = playerData.data.changeOrder
            // }
            const searchData = queryString.parse(this.props.location.search)
            this.setState({respon:true})
            this.setState({ lastVisit: playerData.data.lastVisit, gameType, gameSubType, ringType, dateRange, totalHandPlayed, changeOrder: changeOrder })
            // if (playerData.data.isMygameLanding || searchData.isMygameLogoClick || window.location.href.indexOf('/home')) {
            //     location = `/home?${queryString.stringify({ gameType, gameSubType, ringType, dateRange, totalHandPlayed })}`
            // } else if (!playerData.data.isMygameLanding) {
            //     if (playerData.data.singleReport)
            //         location = `/ReportCard/${localStorage.getItem('accountName')}/${playerData.data.gameType}?${queryString.stringify({
            //             hitLevel: 'All Level',
            //             hitRange: playerData.data.dateRange,
            //             hitType: playerData.data.ringType
            //         })}`
            //     else
            //         location = '/SkillLevel?logintype=player'
            // }
            location = `/home?${queryString.stringify({ gameType, gameSubType, ringType, dateRange, totalHandPlayed })}`
            this.setState({ location: location })
            return
        } else {
            this.setState({ location: `/` })
            return
        }
    }

    async componentDidMount() {
        // if (Object.keys(queryString.parse(this.props.location.search)).length === 0)
        await this.checkLastHandsDtls()
        await this.props.setHeaderTitle(this.state.title);
        await this.getSkillLevel(this.state.gameType, this.state.gameSubType, this.state.dateRange, this.state.ringType)
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = 'HomePage';
        track.hit_attribute1 = this.state.gameType;
        track.hit_attribute2 = this.state.totalHandPlayed;
        track.hit_attribute3 = this.state.totalHandPlayed > 100 ? "Report" : "No Report";
        saveActivity(track);
    }

    disableOnBoard = async () => {
        this.setState({ loading: true, isOnBoard: 0 })
        await updateOnBoard()
        this.setState({ loading: false })
    }

    openFilter = () => {
        let prevGameType = this.state.gameType
        if (this.state.prevGameType === '')
            this.setState({ prevGameType })
        this.setState({ openFilter: true })
    }


    closeFilter = () => {
        this.setState({ openFilter: false })
    }

    submitLandingPageFilter = async (gameType, dateRange) => {
        let gameSubType = ""
        let ringType = ""
        console.log("submitLandingPageFilter", gameType, dateRange);
        if (gameType === "cash") {
            gameSubType = "NLH"
            ringType = '6-seater'
        } else if (gameType === "PLO") {
            gameSubType = "All"
            ringType = '6-seater'
        } else if (gameType === "tournament") {
            gameSubType = "NLH"
            ringType = 'Full Ring'
        } else {
            gameSubType = "All"
            ringType = '3 max'
        }
        this.setState({ gameType, gameSubType, dateRange, ringType })
        await this.getSkillLevel(gameType, gameSubType, dateRange, ringType)
        this.setState({ openFilter: false })

    }

    getSkillLevel = (gameType, gameSubType, dateRange, ringType) => {
        this.setState({ loading: true })
        apiService(`${baseUrl}/reportCard/getLandingPageSkillLevel`,
            {
                gameType: gameType,
                gameSubType: (gameType === 'cash' || gameType === 'tournament') ? "NLH" : gameSubType,
                ringType: ringType,
                dateRange: dateRange,
                accountName: localStorage.getItem("accountName"),
            },
            async (data) => {
                this.setState({
                    gameHandsCounts: data[0].gameHandsCounts,
                    summaryInfo: data[0],
                    totalHandPlayed: data[0].hands,
                    changeOrder:data[0].changeOrder,
                    ringType: gameType === "spin" ? "Heads-up" : data[0].ringType
                })
                this.setState({ loading: false })
            }, (error) => {
                this.setState({ loading: false })
                console.log("Error:", error)
            })
    }

    onMGLClick = () => {
        if (this.state.wnd && !this.state.wnd.closed) {
            this.state.wnd.focus();
        } else{
            if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
                //for mac and vc clients
                  DispatcherFunction("app:menu=3813&name=MYGAME_WHIZ", {
                    "MYGAME_WHIZ_URL": 'https://' + window.location.hostname + '/liveview',
                    "height": "670",
                    "width": "350"
                  })
                }
           else{
            let wnd = window.open('https://' + window.location.hostname +'/liveview', window.opener ? '_self' : '_blank', 'location=yes,height=670,width=350,scrollbars=yes,status=yes');
           this.setState({wnd})
           }
           
          }
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = 'MeetWhiz';
        track.hit_attribute1 = this.state.gameType;
        saveActivity(track);
    }

    learnMoreOnClickHandler = (type) => {
        if (type === 'courses') {
            this.props.history.push('/course')
        }
        else {
            this.setState({
                count: 1,
                learnMoreType: type
            })
        }
    }
    prev = () => {
        if (this.state && this.state.count > 1) {
            this.setState({ count: this.state.count - 1 });
        }
    }
    next = async (length) => {
        if (this.state.count < length) {
            this.setState({ count: this.state.count + 1 });
        }
    }
    reset = () => {
        this.setState({ count: 1 })
    }

    handleQuizOpen = (e) => {
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = 'QuizLaunch';
       // track.hit_attribute1 = "Starting Hands";
       track.hit_attribute1 = "Quiz Types";
        saveActivity(track);
        axiosCallService('/quiz/getQuizTypes').then(res => {
            this.props.loadQuizTypeDetails(res.data)
            this.props.loadQuizDetails([]);
        }).catch(err => {
            console.log(err);
        })
    }

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()

        let first_name = localStorage.getItem("first_name") ? localStorage.getItem("first_name") : "";
        const { gameType, gameSubType, ringType, dateRange, totalHandPlayed, summaryInfo, changeOrder } = this.state;
        let gameName = "";
        if (gameType === "cash") {
            gameName = "NLH Cash Games"
        } else if (gameType === "PLO") {
            gameName = "PLO Cash Games"
        } else if (gameType === "tournament") {
            gameName = "Tournament Games"
        } else {
            gameName = "Spin Games"
        }
        return (
            <div className='base_background'
                style={{ backgroundImage: `url(https://${domain}${backgroundImage})` }}>
                {this.state.location != '' && <Redirect to={this.state.location} />}
                <LearnMore gameType={this.state.gameType} launchedFrom={"MyGame Landing Page"} baseUrlImg={"//" + domain} 
                openFandamentPositionCourse={() => {
                    if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
                        //for mac and vc clients
                        DispatcherFunction("app:menu=3812&name=MYGAME_COURSES",{
                          "MYGAME_COURSES_URL": 'https://' + window.location.hostname + '/course/Fundamentals/Position%20Part-1'
                        })
                      }
                 else{
                    this.props.history.push('/course/Fundamentals/Position%20Part-1')
                 }
                }} />
                <style>{"\
                    @media only screen and (max-width: 1024px) {\
                      body {\
                        background-color: #FFFFFF !important;\
                      }\
                    }\
                  "}</style>
                  <style>{`\
                  .staredHandColor, .advice_controls {\
                    color: ${themeColor};\
                  }\
                  .staredHandColor:hover {\
                    color: ${themeColor};\
                  }\
                  .staredHandColorUnstar {\
                    color: #C1C1C1;\
                  }\
                  .advice_selected_bullet {\
                    background-color: ${themeColor}
                  }\
                `}</style>
                {this.state.isOnBoard == 1 && <OnBoard disableOnBoard={this.disableOnBoard} />}
                {!this.state.loading && !this.state.respon? <Loading /> : null}
                <MediaQuery minWidth={1025} ><div className="base_home_part_3_Order">
                    <div className="base_home_part_3_inside container">
                        <LandingTab
                            dateRange={this.state.dateRange}
                            gameHandsCounts={this.state.gameHandsCounts}
                            gameType={this.state.gameType}
                            totalHandPlayed={this.state.totalHandPlayed}
                            submitLandingPageFilter={this.submitLandingPageFilter} />
                    </div>
                </div></MediaQuery>
                <div className="base_home container" style={{ paddingBottom: "20px" }} >
                    <div className="base_home_header">
                        <div className="base_home_header_content">
                            Welcome {this.state.lastVisit ? "back" : ""} <span style={{ textTransform: "capitalize" }}>{first_name.toLowerCase()}</span>!&nbsp;
                            <span className="baseHomeHeader_sm" >
                                <MediaQuery maxWidth={1024} >
                                    <span className="base_home_header_filter">
                                        <span onClick={this.openFilter}><i className="fa fa-filter base_home_header_filter_icon"
                                            style={{
                                                color: themeColor
                                            }}
                                        ></i></span>
                                        <span className="base_home_game_filter_content">{gameName} , {this.state.dateRange}</span>
                                    </span>
                                </MediaQuery>
                            </span>
                        </div>


                    </div>

                    <div className={`base_home_part_1 ${changeOrder && `base_home_part_1_Order`}`}>
                        < Observations
                            gameType={gameType}
                            i18next={i18next}
                            ringType={ringType}
                            dateRange={dateRange}
                            gameSubType={gameSubType}
                            totalHandPlayed={totalHandPlayed}
                        />
                        <MeetWhiz
                            gameType={gameType}
                            onMGLClick={this.onMGLClick}
                            imageUrl={"//" + domain + "/images" + WhizHelmet} />
                    </div>
                    <div className={`base_home_part_2 ${changeOrder && `base_home_part_2_Order`}`}>
                        <div className="base_home_analyse">
                            <AnalysingHands
                                gameType={gameType == "PLO" ? "plo" : gameType}
                                ringType={gameType === "spin" ? "3 max" : ringType}
                                dateRange={dateRange}
                                gameSubType={gameSubType}
                                summaryInfo={summaryInfo}
                                totalHandPlayed={totalHandPlayed} />
                        </div>
                        {this.state.openFilter &&
                            <LandingPageFilter
                                dateRange={this.state.dateRange}
                                gameType={this.state.gameType}
                                closeFilter={this.closeFilter}
                                submitLandingPageFilter={this.submitLandingPageFilter} />}
                        <LearnMoreHome
                            gameType={gameType}
                            onClickHandler={this.learnMoreOnClickHandler}
                            learnMoreType={this.state.learnMoreType}
                            prev={this.prev}
                            next={this.next}
                            count={this.state.count}
                            reset={this.reset}
                            handleQuizOpen={this.handleQuizOpen}
                            history={this.props.history}
                        />
                    </div>
                    {!this.state.fromClient && ["PartyPoker","PARTYPOKER"].includes(localStorage.getItem("loggedInType")) ? 
                        <div className={`partypokerPrmotion ${changeOrder && `partypokerPrmotion_order`}`}>
                            <span>Want to Play Now or Download the PartyPoker app?</span>
                            <span>  <button data-e2e="playnow or download" className="partyPokerPlayBtn" onClick={() => {
                                let track = {}
                                track.hit_page = 'HomePage';
                                track.hit_type = 'PlayNow';
                                track.hit_attribute1 = this.state.gameType;
                                saveActivity(track);
                                //window.open(this.state.download_redirecturl[localStorage.getItem("loggedInType")])
                                window.open(" https://promo.partypoker.com/en/promo/launch?P=PartyPoker")
                            }}
                                style={{
                                    backgroundColor: themeColor,
                                    color: themeTextColor,
                                }}
                            >

                                Play Now / Download
                                    </button>
                            </span>
                        </div>
                       :<div className={`partypokerPrmotion ${changeOrder && `partypokerPrmotion_order`}`}></div>
                    }

                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        lang: state.header.lang
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
        loadQuizTypeDetails: (quiz) => dispatch(actions.loadQuizTypeDetails(quiz)),
        loadQuizDetails : (quiz) => dispatch(actions.loadQuizDetails(quiz))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseStructure);




/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/BaseStructure.js
 **/